import type { FC } from 'react'
import type { CellProps, IStatuses } from '../../../interfaces'

import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getStatus } from '..'
// import { checkStatus } from "../../../functions/checkStatus"
import { checkStatus } from '../../../functions/checkStatus'
// import { statusDescription } from "../../../models/const"
import { selectStatuses, selectStatusMapping } from '../../../store/payment-files/selector'

interface Props extends CellProps {
  status?: string
  titleStatus?: string
}

const setDescription = (status: string | undefined, statuses: IStatuses[]) => {
  if (!status) return ''
  const statusObj: IStatuses | undefined = statuses.find(item => item.id.toString() === status)
  return statusObj === undefined ? '' : statusObj.statusName
}

const CellWithStatus: FC<Props> = ({ title, status, titleStatus: _titleStatus }) => {
  const mapStatus = useSelector(selectStatusMapping)
  const statuses = useSelector(selectStatuses)

  const setIcons = (statusStr: string) => {
    const color = checkStatus(statusStr, mapStatus)
    const status = color.split('-')

    const Component = getStatus(status[1] || '')
    return Component ? <Component /> : null
  }

  const setDescriptionMemo = useMemo(() => setDescription(status, statuses), [status, statuses])

  return (
    <div className='custom-cell custom-cell--status'>
      <div className='custom-cell__title'>{title}</div>
      {status === 'Pending' ? (
        ''
      ) : (
        <div className='custom-cell__status-line'>
          {status && setIcons(status)}
          {status !== undefined && checkStatus(status, mapStatus) === 'color-pending' ? (
            <div className='custom-cell__description'>
              {status !== undefined && setDescriptionMemo}
            </div>
          ) : (
            <div className='custom-cell__status'>{status !== undefined && setDescriptionMemo}</div>
          )}
        </div>
      )}
    </div>
  )
}

export default CellWithStatus
